"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTracking = require("react-tracking");

var _iconApple = _interopRequireDefault(require("../../images/icon-apple.svg"));

var _iconFacebook = _interopRequireDefault(require("../../images/icon-facebook.svg"));

var _iconGoogle = _interopRequireDefault(require("../../images/icon-google.svg"));

var _iconLine = _interopRequireDefault(require("../../images/icon-line.svg"));

var _stitches = require("../../stitches.config");

var StyledSocialButton = (0, _stitches.styled)('button', {
  alignItems: 'center',
  border: '0',
  borderRadius: '$buttonShape$default',
  display: 'flex',
  fontSize: '$normal',
  fontWeight: '$semiBold',
  justifyContent: 'center',
  marginBottom: '10px',
  marginTop: '10px',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
  '&:hover': {
    cursor: 'pointer'
  },
  variants: {
    social: {
      apple: {
        backgroundColor: '$blackDarkest',
        color: '$white'
      },
      facebook: {
        backgroundColor: '#3b5998',
        color: '$white'
      },
      google: {
        backgroundColor: '$white',
        border: '1px solid $blackDarkest'
      },
      line: {
        backgroundColor: '#00c300',
        color: '$white'
      }
    }
  }
});
var StyledSocialIcon = (0, _stitches.styled)('img', {
  height: '24px',
  marginRight: '10px'
});
var socials = {
  apple: {
    icon: _iconApple.default
  },
  facebook: {
    icon: _iconFacebook.default
  },
  google: {
    icon: _iconGoogle.default
  },
  line: {
    icon: _iconLine.default
  }
};
/**
 * A [Button component](/story/elements-button--default) that is used only for social oauth logins. Has a variant per each supported social service.
 */

var SocialButton = function SocialButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      provider = _ref.provider;

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var handleClick = function handleClick() {
    trackEvent({
      event_name: "".concat(provider, "-button"),
      event_type: 'click'
    });
    onClick();
  };

  return /*#__PURE__*/_react.default.createElement(StyledSocialButton, {
    id: "".concat(provider, "-auth-button"),
    social: provider,
    type: "button",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(StyledSocialIcon, {
    alt: "".concat(provider, " icon"),
    src: socials[provider].icon
  }), /*#__PURE__*/_react.default.createElement("span", null, children));
};

SocialButton.defaultProps = {};
var _default = SocialButton;
exports.default = _default;